import React from 'react';
import { Alert, AlertTitle, AlertText, AlertActions, AlertDismissButton } from '@fiverr-private/feedback';
import { Link } from '@fiverr-private/typography';
import pathfinder from '@fiverr-private/pathfinder';
import { AppI18n } from '../../../i18n';
import { PortfolioModerationReason } from '../../../gql-operations/gql-generated';
import { useModerationAlert } from '../useModerationAlert';

interface ModerationRemovedAlertProps {
  reason?: PortfolioModerationReason;
  projectId: string;
}

export const articlesLinks = {
  NON_ORIGINAL_CONTENT: '34551428987665-Portfolio-violations#h_01JSBNV0H9WQKMR9QXW04BTWHE',
  OBJECTIONABLE_CONTENT: '34551428987665-Portfolio-violations#h_01JSBNTQYA91RJQQPYBCDZWGST',
  INAPPROPRIATE_CONTENT: '34551428987665-Portfolio-violations#h_01JSBNTQYA91RJQQPYBCDZWGST',
  UNAUTHORIZED_USAGE: '34551428987665-Portfolio-violations#h_01JSBNV4AVJK58VNPP895A30E1',
  PROHIBITED_SERVICES: '34551428987665-Portfolio-violations#h_01JSBNTN58V0DERSD0DHBCPT10',
  CONTAINS_PAYMENT_METHOD: '34551428987665-Portfolio-violations#h_01JSBNTTWZSHVXRPXAPNEDWJJV',
  INTELLECTUAL_PROPERTY_VIOLATION: '34551428987665-Portfolio-violations#h_01JSBNTXNRA9BSRJKVH47TC54Y',
  UNSPECIFIED: '34551428987665',
};

export const MODERATION_ALERT_LS_NAME = 'portfolio_moderation_modal_alert_closed';

export const ModerationRemovedAlert = ({ projectId, reason }: ModerationRemovedAlertProps) => {
  const moderationAlertName = `${MODERATION_ALERT_LS_NAME} + '_' + ${projectId}`;
  const { isModerationAlertClosed, closeModerationAlert } = useModerationAlert(moderationAlertName);
  const articleId = reason ? articlesLinks[reason] : articlesLinks.UNSPECIFIED;

  if (isModerationAlertClosed === undefined || isModerationAlertClosed) {
    return null;
  }

  return (
    <Alert variant="warning">
      <AlertTitle>
        <AppI18n k="removed_alert.title" />
      </AlertTitle>
      <AlertText>
        <AppI18n k={`removed_alert.description.${reason || PortfolioModerationReason.Unspecified}`} />
        <AppI18n k="removed_alert.email_info" />
        <Link color="blue_1100" href={pathfinder('help_center_article', { article_id: articleId })} cursor="pointer">
          <AppI18n k="removed_alert.learn_more" />
        </Link>
      </AlertText>
      <AlertActions>
        <AlertDismissButton onClick={closeModerationAlert} />
      </AlertActions>
    </Alert>
  );
};
